import {getSchedule} from './api';

export async function getContractSchedule(contract) {
  let schedule = await getSchedule(contract.request.contractNumber);
  schedule.data.billingAccountNumber = contract.billingAccountNumber;
  return schedule.data;
}
